// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I59n","colBig":"styles_colBig__9Hca5","colSmall":"styles_colSmall__3JxGM"};